import { AppRemixIcon } from '@/layout/AppComponents';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';
import colors from '../../../../../../constants/colors';
import ProbSevRiskElement from '../../../LegalCompliance/Evaluation/CardElements/ProbSevRisk/ProbSevRiskElement';
import Translator from '../../../../../components/helpers/Translator';
import GGCLPlantRowIconBlock from './GGCLPlantRowIconBlock';

export default function GGCLPlantRow(props) {
  const { plantIndex, obligationID, onSelectedPlant } = props;
  const { moduleBridgeHex } = useParams();
  const permissions = useSelector(
    (state) => state.module[moduleBridgeHex].permissions.ggcl
  );
  const plant = useSelector(
    (s) => s.currentPage?.plantListTab?.[obligationID][plantIndex]
  );

  return (
    <PlantContainer
      permissions={permissions}
      border={plant.border || 'white'}
      onClick={onSelectedPlant}
    >
      <div className="ggcl-pr-info">
        <h3>{plant.name}</h3>
      </div>
      <div className="ggcl-pr-info-blocks">
        <span>
          {plant.lastEvidence || (
            <Translator
              file="module-globallegalCompliance"
              name="without.evidences"
            />
          )}
        </span>
      </div>
      <div className="ggcl-pr-info-blocks">
        <CalendarEventsBlock>
          {plant.nextCalendarDates.length === 0 && (
            <span>
              <Translator
                file="module-globallegalCompliance"
                name="without.dates"
              />
            </span>
          )}
          {plant.nextCalendarDates?.map((cd) => (
            <li
              key={cd.id}
              className={
                moment(cd.date, 'DD/MM/YYYY').isBefore(moment())
                  ? 'text-danger'
                  : moment(cd.date, 'DD/MM/YYYY').isBefore(
                      moment().add(3, 'months')
                    )
                  ? 'event-warning'
                  : ''
              }
            >
              <AppRemixIcon
                icon={
                  moment(cd.date, 'DD/MM/YYYY').isBefore(moment())
                    ? 'alert'
                    : 'timer'
                }
                className="mr-1"
              />
              <span>{cd.date}</span>
              {cd.comment && (
                <AppRemixIcon
                  icon="chat-4"
                  className="ml-1 mr-1"
                  filled
                  title={cd.comment}
                  color={colors.primaryLight}
                />
              )}
              <AppRemixIcon icon="chat-t" className="mr-1" />
            </li>
          ))}
        </CalendarEventsBlock>
      </div>
      {(permissions?.probability ||
        permissions?.severity ||
        permissions?.risk) && (
        <div className="ggcl-pr-prob-sev">
          {permissions?.probability && (
            <ProbSevRiskElement type="prob" state={plant.probability} />
          )}
          {permissions?.severity && (
            <ProbSevRiskElement type="sev" state={plant.severity} />
          )}
          {permissions?.risk && (
            <ProbSevRiskElement type="flat-risk" state={plant.risk} />
          )}
        </div>
      )}

      <div className="ggcl-pr-icons">
        <GGCLPlantRowIconBlock
          plant={plant}
          plantIndex={plantIndex}
          obligationID={obligationID}
        />
      </div>
    </PlantContainer>
  );
}

const PlantContainer = styled.li`
  display: grid;
  grid-template-columns:
    1fr
    150px
    150px
    ${(props) =>
      (props.permissions?.probability ||
        props.permissions?.severity ||
        props.permissions?.risk) &&
      '140px'} //ProbSev block
    86px;
  height: 60px;
  overflow: hidden;
  border-bottom: 1px solid ${colors.grey400};
  padding: 0;
  margin: 0;
  border-left: 12px solid ${(props) => props.border};
  cursor: pointer;
  .ggcl-pr-info {
    padding: 0 6px;
  }
  .ggcl-pr-prob-sev {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    border-left: 1px solid ${colors.grey400};
    padding: 15px 6px 0 6px;
  }
  h3 {
    font-size: 14px;
    color: ${colors.primary};
    text-transform: uppercase;
  }
  .ggcl-pr-info-blocks {
    border-left: 1px solid ${colors.grey400};
    padding-left: 4px;
    text-align: center;
    span {
      font-size: 10px;
      font-weight: bold;
      display: block;
      letter-spacing: 1px;
    }
  }
  .ggcl-pr-icons {
    display: grid;
    border-left: 1px solid ${colors.grey400};
    grid-template-columns: 20px 20px 20px;
    grid-template-rows: 20px 20px;
    padding: 0 6px 0 6px;
  }
`;

const CalendarEventsBlock = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 0 0 6px;
  overflow-y: auto;
  max-height: 64px;
  li {
    font-size: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    &.event-warning {
      color: ${colors.state2};
    }
  }
  span {
    font-size: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    display: inline-block !important;
  }
`;
